<!-- eslint-disable -->
<template lang="pug">
    g
        g.city-wrapper.is-invisible(
            v-for="(city, index) in cities"
            :key="index"
            :is="city.name"
            v-if="continents[city.name] === continent && user.availableLocationId >= index + 1"
            :showTransition="city.isAvailable"
            :city="city.name"
            :zoomEnded="zoomEnded"
            :panEnded="panEnded"
            @openModal="$emit('openModal')"
            @disableActions="$emit('disableActions', $event)"
            @transition="$emit('transition', arguments[0], arguments[1])"
        )
</template>

<style lang="scss">
    .city-wrapper:not(.is-invisible) .location {
        cursor: pointer;
    }
</style>

<script>
    /*eslint-disable*/
    import cities from '../../../config/cities.json'
    import continents from '../../../config/continents'
    import {mapState} from 'vuex'

    const Moscow = () => import('./map-assets/elements/Eurasia/Moscow.vue')
    const Oslo = () => import('./map-assets/elements/Eurasia/Oslo.vue')
    const Berlin = () => import('./map-assets/elements/Eurasia/Berlin.vue')
    const Paris = () => import('./map-assets/elements/Eurasia/Paris.vue')
    const Madrid = () => import('./map-assets/elements/Eurasia/Madrid.vue')
    const Rome = () => import('./map-assets/elements/Eurasia/Rome.vue')
    const Istanbul = () => import('./map-assets/elements/Eurasia/Istanbul.vue')
    const Astana = () => import('./map-assets/elements/Eurasia/Astana.vue')
    const NewDelhi = () => import('./map-assets/elements/Eurasia/NewDelhi.vue')
    const Bangkok = () => import('./map-assets/elements/Eurasia/Bangkok.vue')
    const Beijing = () => import('./map-assets/elements/Eurasia/Beijing.vue')
    const Tokyo = () => import('./map-assets/elements/Eurasia/Tokyo.vue')

    const Cairo = () => import('./map-assets/elements/Africa/Cairo.vue')
    const Algeria = () => import('./map-assets/elements/Africa/Algeria.vue')
    const Marrakesh = () => import('./map-assets/elements/Africa/Marrakesh.vue')
    const SaharaDesert = () => import('./map-assets/elements/Africa/SaharaDesert.vue')
    const Bamako = () => import('./map-assets/elements/Africa/Bamako.vue')
    const Kinshasa = () => import('./map-assets/elements/Africa/Kinshasa.vue')
    const CongoRiver = () => import('./map-assets/elements/Africa/CongoRiver.vue')
    const CapeTown = () => import('./map-assets/elements/Africa/CapeTown.vue')
    const Tanzania = () => import('./map-assets/elements/Africa/Tanzania.vue')
    const MountKilimanjaro = () => import('./map-assets/elements/Africa/MountKilimanjaro.vue')
    const AddisAbaba = () => import('./map-assets/elements/Africa/AddisAbaba.vue')
    const MadagascarIsland = () => import('./map-assets/elements/Africa/MadagascarIsland.vue')

    const ChurchOfTheHolyTrinity = () => import('./map-assets/elements/Antarctica/ChurchOfTheHolyTrinity.vue')
    const MountElsworth = () => import('./map-assets/elements/Antarctica/MountElsworth.vue')
    const Iceberg = () => import('./map-assets/elements/Antarctica/Iceberg.vue')
    const IceMarathon = () => import('./map-assets/elements/Antarctica/IceMarathon.vue')
    const AntarcticStationAmundsenScott = () => import('./map-assets/elements/Antarctica/AntarcticStationAmundsenScott.vue')
    const Icebreaker = () => import('./map-assets/elements/Antarctica/Icebreaker.vue')
    const AnimalsOfAntarctica = () => import('./map-assets/elements/Antarctica/AnimalsOfAntarctica.vue')
    const ResearchStationProgress = () => import('./map-assets/elements/Antarctica/ResearchStationProgress.vue')

    const EasterIsland = () => import('./map-assets/elements/SouthAmerica/EasterIsland.vue')
    const AtacamaDesert = () => import('./map-assets/elements/SouthAmerica/AtacamaDesert.vue')
    const BuenosAires = () => import('./map-assets/elements/SouthAmerica/Buenos-Aires.vue')
    const PuntoTombo = () => import('./map-assets/elements/SouthAmerica/Punto-Tombo.vue')
    const ColoradoLagoon = () => import('./map-assets/elements/SouthAmerica/ColoradoLagoon.vue')
    const MachuPicchu = () => import('./map-assets/elements/SouthAmerica/Machu-Picchu.vue')
    const Quito = () => import('./map-assets/elements/SouthAmerica/Quito.vue')
    const GalapagosIslands = () => import('./map-assets/elements/SouthAmerica/GalapagosIslands.vue')
    const Guatape = () => import('./map-assets/elements/SouthAmerica/Guatape.vue')
    const AngelFalls = () => import('./map-assets/elements/SouthAmerica/AngelFalls.vue')
    const AmazonRiver = () => import('./map-assets/elements/SouthAmerica/AmazonRiver.vue')
    const RioDeJaneiro = () => import('./map-assets/elements/SouthAmerica/RioDeJaneiro.vue')

    const JurassicPark = () => import('./map-assets/elements/NorthAmerica/JurassicPark.vue')
    const Kingston = () => import('./map-assets/elements/NorthAmerica/Kingston.vue')
    const SanJose = () => import('./map-assets/elements/NorthAmerica/SanJose.vue')
    const Palenque = () => import('./map-assets/elements/NorthAmerica/Palenque.vue')
    const MexicoCity = () => import('./map-assets/elements/NorthAmerica/MexicoCity.vue')
    const Disneyland = () => import('./map-assets/elements/NorthAmerica/Disneyland.vue')
    const NewYork = () => import('./map-assets/elements/NorthAmerica/NewYork.vue')
    const Ottawa = () => import('./map-assets/elements/NorthAmerica/Ottawa.vue')
    const Calgary = () => import('./map-assets/elements/NorthAmerica/Calgary.vue')
    const StanleyPark = () => import('./map-assets/elements/NorthAmerica/StanleyPark.vue')
    const Alaska = () => import('./map-assets/elements/NorthAmerica/Alaska.vue')
    const Greenland = () => import('./map-assets/elements/NorthAmerica/Greenland.vue')

    const Wellington = () => import('./map-assets/elements/Australia/Wellington.vue')
    const Hobbiton = () => import('./map-assets/elements/Australia/Hobbiton.vue')
    const GreatBarrierReef = () => import('./map-assets/elements/Australia/GreatBarrierReef.vue')
    const PapuaNewGuinea = () => import('./map-assets/elements/Australia/PapuaNewGuinea.vue')
    const CockatooNationalPark = () => import('./map-assets/elements/Australia/CockatooNationalPark.vue')
    const PinnacleDesert = () => import('./map-assets/elements/Australia/PinnacleDesert.vue')
    const LakeHiller = () => import('./map-assets/elements/Australia/LakeHiller.vue')
    const CliffUluru = () => import('./map-assets/elements/Australia/CliffUluru.vue')
    const KangarooIsland = () => import('./map-assets/elements/Australia/KangarooIsland.vue')
    const RainForest = () => import('./map-assets/elements/Australia/RainForest.vue')
    const BlueMountains = () => import('./map-assets/elements/Australia/BlueMountains.vue')
    const Sydney = () => import('./map-assets/elements/Australia/Sydney.vue')

    const ISS = () => import('./map-assets/elements/Space/ISS.vue');
    const Moon = () => import('./map-assets/elements/Space/Moon.vue');
    const Sun = () => import('./map-assets/elements/Space/Sun.vue');
    const Mercury = () => import('./map-assets/elements/Space/Mercury.vue');
    const Jupiter = () => import('./map-assets/elements/Space/Jupiter.vue');
    const Mars = () => import('./map-assets/elements/Space/Mars.vue');
    const Neptune = () => import('./map-assets/elements/Space/Neptune.vue');
    const Asteroids = () => import('./map-assets/elements/Space/Asteroids.vue');
    const Uranus = () => import('./map-assets/elements/Space/Uranus.vue');
    const Saturn = () => import('./map-assets/elements/Space/Saturn.vue');
    const BlackHole = () => import('./map-assets/elements/Space/BlackHole.vue');
    const Venus = () => import('./map-assets/elements/Space/Venus.vue');

    export default {
        props: {
            availableCities: Array,
            zoomEnded: Boolean,
            panEnded: Boolean,
            continent: String
        },
        data () {
            return {
                continents
            };
        },
        components: {
            Moscow,
            Oslo,
            Berlin,
            Paris,
            Madrid,
            Rome,
            Istanbul,
            Astana,
            NewDelhi,
            Bangkok,
            Beijing,
            Tokyo,
            Cairo,
            Algeria,
            Marrakesh,
            SaharaDesert,
            Bamako,
            Kinshasa,
            CongoRiver,
            CapeTown,
            Tanzania,
            MountKilimanjaro,
            AddisAbaba,
            MadagascarIsland,
            EasterIsland,
            AtacamaDesert,
            BuenosAires,
            PuntoTombo,
            ColoradoLagoon,
            MachuPicchu,
            Quito,
            Guatape,
            AngelFalls,
            AmazonRiver,
            RioDeJaneiro,
            GalapagosIslands,
            Wellington,
            Hobbiton,
            GreatBarrierReef,
            PapuaNewGuinea,
            CockatooNationalPark,
            PinnacleDesert,
            LakeHiller,
            CliffUluru,
            KangarooIsland,
            BlueMountains,
            RainForest,
            Sydney,
            ChurchOfTheHolyTrinity,
            MountElsworth,
            Iceberg,
            IceMarathon,
            AntarcticStationAmundsenScott,
            Icebreaker,
            AnimalsOfAntarctica,
            ResearchStationProgress,
            JurassicPark,
            Kingston,
            SanJose,
            Palenque,
            MexicoCity,
            Disneyland,
            NewYork,
            Ottawa,
            Calgary,
            StanleyPark,
            Alaska,
            Greenland,
            ISS,
            Moon,
            Sun,
            Mercury,
            Jupiter,
            Mars,
            Neptune,
            Asteroids,
            Uranus,
            Saturn,
            BlackHole,
            Venus
        },
        computed: {
            cities () {
                return cities.map(city => {
                    return {name: city, isAvailable: this.availableCities.includes(city)}
                })
            },
            ...mapState({
                user: state => state.auth.user
            })
        },
    }
</script>